import Head from 'next/head';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import Layout from 'components/layout';
import Header from 'components/support/header';
import Preview from 'components/preview';
import Loading from 'components/loading';
import { actionServer } from 'action/index';
import { useMemo } from 'react';
export default function Home(props: any) {
  const { detail } = props;
  const router = useRouter();

  const previewData = useMemo(() => {
    if (detail && detail.title) {
      const { content, id, title, resourceList } = detail;
      return {
        content,
        id,
        intro: title,
        enclosureList: resourceList,
      };
    }
    return null;
  }, [detail]);

  if (router.isFallback) {
    return <Loading />;
  }
  return (
    <Layout>
      <Head>
        <title>售后流程 - 小鱼易连-官网-让世界零距离</title>
      </Head>
      <section>
        <Header pageKey="flow" />
        {previewData && <Preview detail={{ ...previewData }} />}
      </section>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const detail = await actionServer.getSalesProcess();
  return {
    props: {
      detail,
    },
    revalidate: 30,
  };
};
